import { NavigationMenuId } from '../enums/navigationMenuId'
import { TransformItemsStructure } from './transformItemsStructure'

const SECTIONS: ReadonlyArray<ReadonlyArray<NavigationMenuId>> = [
  // Section 1 (Quick Start)
  [NavigationMenuId.QuickStart],
  // Section 2
  [NavigationMenuId.Overview, NavigationMenuId.ThingsToDo],
  // Section 3
  [NavigationMenuId.Sales, NavigationMenuId.Expenses, NavigationMenuId.BankingReact, NavigationMenuId.Banking],
  // Section 4
  [NavigationMenuId.Accounting, NavigationMenuId.Reports],
]

export const getSectionStartIds = (
  navigationMenuItems: TransformItemsStructure[],
  sections: ReadonlyArray<ReadonlyArray<NavigationMenuId>> = SECTIONS,
) => {
  const available = new Set(navigationMenuItems.map((item) => item.id))
  return sections
    .map((section) => section.find((id) => available.has(id)))
    .filter((id): id is NavigationMenuId => Boolean(id))
}
